import { render, staticRenderFns } from "./get-code.vue?vue&type=template&id=fd77c246"
import script from "./get-code.vue?vue&type=script&lang=ts"
export * from "./get-code.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports